import { config, getCompleteDomain, getServerEnvironment } from "./helper";

const { Url, MerchantUrl } = config(getServerEnvironment(getCompleteDomain()));

export const BACKEND_API = Url;

// Merchant panel backend — used for endpoints that are served by the merchant
// panel rather than the admin panel (e.g. company/business/registration types).
export const MERCHANT_BACKEND_API = MerchantUrl;

export const LOGIN_API = `${BACKEND_API}admin/login`;

export const FORGOT_PASSWORD_API = `${BACKEND_API}admin/passwordreset/forgotpassword`;

export const OTP_VERIFY_API = `${BACKEND_API}admin/passwordreset/otpverify/`;

export const CHANGE_PASSWORD = `${BACKEND_API}admin/passwordreset/changepassword`;

export const TELEGRAM_API_BASE_URL = `${BACKEND_API}TelegramBot/`;

// REPORTS API:

export const CHARGE_BACK_UPLOAD_API = `${BACKEND_API}chargeBack/upload`;
export const GANRATEINVOICE = `${BACKEND_API}settlement/findbymid/{mid}`;

export const GET_BALANCE_BY_ID = `${BACKEND_API}merchant/payoutRagister/getBalanceById`;

export const GETALL_CHARGE_BACK_API = `${BACKEND_API}chargeBack`;

export const GET_CHARGE_BACK_BY_CONDITION_API = `${BACKEND_API}chargeBack/ByCondition`;

export const GETALL_SETTLEMENT_REPORT_API = `${BACKEND_API}admin/settlement`;

export const SETTLEMENT_UPLOAD_API = `${BACKEND_API}settlement/upload`;

export const GET_SETTLEMENT_BY_CONDITION_API = `${BACKEND_API}settlement/ByCondition`;

export const PAYIN_REPORT_API = `${BACKEND_API}merchant/reports/getAllReport`;

export const PAYIN_REPORT_BY_CONDITION_API = `${BACKEND_API}merchant/reports/getreportByCondition`;

export const PAYOUT_REPORT_API = `${BACKEND_API}admin/payout/getAllUsage`;

export const WITHDRAW_REPORT_API = `${BACKEND_API}merchant/withdrawal/getAllWithdrawal`;

// PHASE1 APIS:

export const GETALL_SUBMITTED_MERCHANT_PHASE1_API = `${BACKEND_API}merchant/onboard/getallmerchant/Submitted`;

export const GET_VIEW_APPROVE_PHASE1_API = `${BACKEND_API}merchant/onboard/getallmerchant/Approved`;

export const GET_VIEW_REJECTED_PHASE1_API = `${BACKEND_API}merchant/onboard/getallmerchant/rejected`;

export const GET_VIEW_PENDING_PHASE1_API = `${BACKEND_API}merchant/onboard/getallmerchant/Pending`;

//  VIEW FILE APIS:
export const VIEW_FILE_UPDATE_STATUS_API = `${BACKEND_API}merchant/onboard/updateStatus`;

export const VIEW_FILE1_API = `${BACKEND_API}merchant/onboard/getmerchantById/`;

export const GET_MERCHANT_BY_ID_PHASE1_API = `${BACKEND_API}merchant/onboard/getmerchantById/`;

export const FETCH_PAYMENT_SERVICES_PHASE1_API = `${BACKEND_API}merchant/paymentType/getALLPaymentType`;

export const SAVE_SELECTED_PAYMENT_SERVICES_API = `${BACKEND_API}merchant/onboard/updatePaymentTypeService/`;

//   PHASE 2 APIS:

export const STAGE2_APPLICATIONS_API = `${BACKEND_API}merchant/onboard/findbystage2/Submitted`;

export const CHECK_FILE_IS_PDF = `${BACKEND_API}merchant/onboard/checkPdf`;

export const STAGE2_APPROVED_API = `${BACKEND_API}merchant/onboard/findbystage2/Approved`;

export const STAGE2_REJECTED_API = `${BACKEND_API}merchant/onboard/findbystage2/rejected`;

export const STAGE2_PENDING_API = `${BACKEND_API}merchant/onboard/findbystage2/Pending`;

// MOA DETAILS API:
export const STAGE2_UPDATE_STATUS_API = `${BACKEND_API}merchant/onboard/updateStage2/`;

export const STAGE2_GET_MERCHANT_BY_ID_API = `${BACKEND_API}merchant/onboard/getmerchantById`;

export const STAGE2_HANDLE_VIEW_DATA_API = `${BACKEND_API}merchant/onboard/viewData/`;

export const STAGE2_VIEW_PDF_API = `${BACKEND_API}merchant/onboard/view-pdf/`;

// VIEW MERCHANT APIS:
export const FETCH_MERCHANT_DETAILS_API = `${BACKEND_API}merchant/getallmerchant`;

export const FETCH_MERCHANT_OPEN_DETAILS_API = `${BACKEND_API}merchant/getmerchantByMid`;

export const FETCH_MERCHANT_TRANSACTION_REPORT_API = `${BACKEND_API}merchant/getAllMerchantWithTransaction`;

export const FETCH_VIEW_MERCHANT_TRANSACTION_REPORT_API = `${BACKEND_API}merchant/reports/getreport`;

// TOOLS APIS:
// ALL PAYOUT REQUEST APIS:

export const FETCH_ALL_PAYOUT_REPORT_API = `${BACKEND_API}merchant/payoutRagister/getAllPayout/`;

export const FETCH_APPROVED_PAYOUT_API = `${BACKEND_API}merchant/payoutRagister/getAllPayoutByStatus/Approved`;

export const FETCH_REJECTED_PAYOUT_API = `${BACKEND_API}merchant/payoutRagister/getAllPayoutByStatus/Rejected`;

export const FETCH_SUBMITTED_PAYOUT_API = `${BACKEND_API}merchant/payoutRagister/getAllPayoutByStatus/Submitted`;

export const FETCH_VIEW_DETAILS_PAYOUT_REPORT_API = `${BACKEND_API}merchant/payoutRagister/getAllPayout`;

export const FETCH_VIEW_DETAILS_UPDATE_PAYOUT_API = `${BACKEND_API}merchant/payoutRagister/reject`;

export const FETCH_VIEW_DETAILS1_PAYOUT_REPORT_API = `${BACKEND_API}merchant/payoutRagister/getAllPayout/`;

// ALL VENDOR REGISTRATION APIS:

export const FETCH_ALL_VENDORS_REGISTRATION_API = `${BACKEND_API}merchant/vendor/getAllVendors`;

export const FETCH_APPROVED_VENDOR_API = `${BACKEND_API}merchant/vendor/getAllVendors/Approved`;

export const FETCH_REJECTED_VENDOR_API = `${BACKEND_API}merchant/vendor/getAllVendors/Rejected`;

export const FETCH_SUBMITTED_VENDOR_API = `${BACKEND_API}merchant/vendor/getAllVendors/Submitted`;

// export const FETCH_VIEW_VENDOR_DETAILS_API = `${BACKEND_API}merchant/vendor/getVendorById/`;
export const FETCH_VIEW_VENDOR_DETAILS_API = `${BACKEND_API}merchant/vendor/getVendorsInfoByid/`;

export const FETCH_VENDER_OLD_ACCOUNTS_DETAILS_BY_VENDER_ID = `${BACKEND_API}merchant/vendor/getOldBeneficiaryVendorsDetailByVendorId/`;

export const FETCH_VIEW_VENDOR_UPDATE_API = `${BACKEND_API}merchant/vendor/updateStatus`;

export const FETCH_VIEW_VENDOR_DETAILS1_API = `${BACKEND_API}merchant/vendor/getVendorById`;

// MERCHANT MANAGEMENT APIS :

export const FETCH_FLAG_EDIT_FORM_API = `${BACKEND_API}merchant/updateMerchantsByMid`;

export const FETCH_FLAG_MANAGEMENT_API = `${BACKEND_API}merchant/getallmerchantsFlags`;

export const FETCH_MANAGE_AMOUNT_API = `${BACKEND_API}merchant/hold/getholddata/`;

export const FETCH_SERVICE_CHARGE_API = `${BACKEND_API}merchant/getallmerchant`;

export const FETCH_SAVE_SERVICE_CHARGE_API = `${BACKEND_API}merchant/save/serviceCharge`;

export const FETCH_WITHDRAW_AMOUNT_API = `${BACKEND_API}merchant/getallmerchant`;

export const FETCH_WITHDRAW_AMOUNT_SAVE_API = `${BACKEND_API}merchant/withdrawal/save`;

export const FETCH_WITHDRAWL_API = `${BACKEND_API}merchant/withdrawal/getAllPandingWithdrawal`;

export const FIND_BY_MID_AND_ORDERNO = `${BACKEND_API}merchant/reports/findByMidAndOrderNo`;

export const UPLOAD_MERCHANT_DOCS = `${BACKEND_API}merchant/reports/findByMidAndOrderNo`;

export const FETCH_ALL_ACCOUNT_DETAILS = `${BACKEND_API}merchant/Account/getAll/AccountDetails`;

export const FETCH_ACCOUNT_DETAILS_BY_MID = `${BACKEND_API}merchant/Account/getAll/AccountDetails/ByMid/`;

export const FETCH_DOCUMENTS_BY_MID_FOR_ACCOUNT = `${BACKEND_API}merchant/Account/viewData/`;

export const FETCH_ALL_FRM_SUBMITTED_FORM = `${BACKEND_API}merchant/frm/getAllFRM`;

export const FETCH_FRM_SUBMITTED_FORM_BY_MID = `${BACKEND_API}merchant/frm/getFRMByMid/`;

export const FETCH_ALL_MERCHANT_VALIDATIONS = `${BACKEND_API}merchant/getallmerchant-validation`;

export const FETCH_ALL_POSTPAID_MERCHANT = `${BACKEND_API}admin/all/postpaid/record`;

export const SAVE_MERCHANT_IP = `${BACKEND_API}saveMerchantService/saveMerchantIp`;

export const FETCH_MERCHANT_SERVICES = `${BACKEND_API}saveMerchantService/GetMerchantIp`;

export const UPDATE_MERCHANT_IP = `${BACKEND_API}saveMerchantService/updateMerchantIp`;

export const FETCH_INVOICE = `${BACKEND_API}admin/postpaid_settlement/findbymid/`;

export const MARK_INVOICE_PAID = `${BACKEND_API}admin/updateBillingDetails`;

export const FETCH_ALL_BANK_FORM_SUBMITTED = `${BACKEND_API}merchant/mdr/getall`;

export const FETCH_BANK_FORM_SUBMITTED_BY_MID = `${BACKEND_API}merchant/mdr/getAllBymid/`;

export const UPLOAD_SWITCH_FILE = `${BACKEND_API}reconciliationReport/switch/upload`;

export const UPLOAD_FINO_SWITCH_FILE = `${BACKEND_API}reconciliationReport/finoRecon/upload`;

export const UPLOAD_NODAL_FILE = `${BACKEND_API}reconciliationReport/consolidated/upload`;

export const UPLOAD_NODAL_TRUE_OR_FALSE = `${BACKEND_API}reconciliationReport/isSwitchFile/upload`;

export const GET_RECONCILIATION_DATA = `${BACKEND_API}reconciliationReport/getAll/reconciliationData`;

export const GET_UPLOADED_PDF_FILES = `${BACKEND_API}reconciliationReport/getUploaded/pdfs`;

export const GET_DOWNLOAD_EXCEL = `${BACKEND_API}merchant/CSV/Download/payin`;

export const PAYIN_FILTER_API = `${BACKEND_API}merchant/reports/getreportByMultpalCondition`;

export const PAYIN_FILTER_API_CSV_DOWNLOAD = `${BACKEND_API}merchant/reports/getreportByMultpalConditionForCsvDownload`;

export const GET_TXN_REPORT_ADVANCE_FILTER = `${BACKEND_API}merchant/reports/getreportByCondition`;

export const SETTLEMENT_MULTIPLE_FILTER_API = `${BACKEND_API}admin/settlement/getSettlementByMultipalCondition`;

export const CHARGEBACK_MULTIPLE_FILTER_API = `${BACKEND_API}chargeBack/ByMultpalCondition`;

export const PAYOUT_MULTIPLE_FILTER_API = `${BACKEND_API}merchant/payoutRagister/merchantPayoutRegister/byMultipleCondition`;

export const WITHDRAW_MULTIPLE_FILTER_API = `${BACKEND_API}merchant/withdrawal/ByMultpalCondition`;

export const LIVE_WITHDRAWL_MULTIPLE_FILTER_API = `${BACKEND_API}merchant/withdrawal/ByMultpalConditionWithoutMid`;

export const GURANTEE_MULTIPLE_FILTER_API = `${BACKEND_API}admin/guarantAmount/chargeBack/ByMultpalCondition`;

export const GET_ALL_MECHANT_PAYOUT_MASTERS = `${BACKEND_API}merchant/merchantPayoutMaster/getAllMerchantPayoutMaster`;

export const GET_ALL_MERCHANT_BRANCHX = `${BACKEND_API}merchant/merchantPayoutMaster/getAllMerchantForBranchX`;

export const GET_ALL_MERCHANT_SURYODAY = `${BACKEND_API}merchant/merchantPayoutMaster/getAllMerchantForSuryoday`;

export const GET_ALL_MERCHANT_VIMO = `${BACKEND_API}merchant/merchantPayoutMaster/getAllMerchantForVimo`;

export const GET_MECHANT_PAYOUT_MASTERS_BY_VEHICLE = `${BACKEND_API}payoutRouting/findPayoutMasterDataByVehicleMaster/`;

export const SAVE_MERCHANT_PAYOUT_MASTER = `${BACKEND_API}merchant/merchantPayoutMaster/saveMerchantPayoutMaster`;

export const SAVE_SURYODAY_PAYOUT_MASTER = `${BACKEND_API}merchant/merchantPayoutMaster/saveMerchantPayoutMasterSuryoday`;

export const SAVE_VIMO_PAYOUT_MASTER = `${BACKEND_API}merchant/merchantPayoutMaster/saveMerchantPayoutMasterForVimo`;

export const DISABLED_DATA_PAYOUT_MASTER = `${BACKEND_API}merchant/merchantPayoutMaster/getAllMerchantPayoutMaster/DisableData`;

export const GET_ALL_ROUTING_VIEW = `${BACKEND_API}admin/MerchantRouting/view-All`;

export const GET_ALL_PAYOUT_ROUTING_VIEW = `${BACKEND_API}admin/MerchantPayoutRouting/view-All`;

export const GET_WALLET_BALANCE_BY_MID = `${BACKEND_API}admin/dropCredit/get/walletBalance/`;

export const FIND_BY_ORDER_NO = `${BACKEND_API}merchant/reports/findByOrderNo`;
export const FIND_PAYIN_DETAILS = `${BACKEND_API}reconciliationReport/getPayinDetail/id`;

export const SID_DETAILS = `${BACKEND_API}admin/sidMaster/getAllEnableDisableSid`;

export const CREATE_SID = `${BACKEND_API}admin/sidMaster/createSID`;

export const GET_ALL_SUBMITTED_PAYOUT_ROUTING = `${BACKEND_API}payoutRouting/getAllMerchantPayoutMaster`;

export const GET_ALL_DAILY_TRANSACTION_DATA_BOX = `${BACKEND_API}LiveReport/getDataBy/timeframe`;

export const GET_ALL_DAILY_TRANSACTION_DATA_TABLE = `${BACKEND_API}merchant/reports/getAllReportWithCurrentDate`;

export const GET_ALL_DAILY_TRANSACTION_DATA_BOX_BY_MID = `${BACKEND_API}LiveReport/getDataBy`;

export const GET_ALL_DAILY_TRANSACTION_DATA_TABLE_BY_MID = `${BACKEND_API}merchant/reports/getAllReportWithCurrentDateWithMid`;

export const GET_ALL_RECON_DATA_BY_MULTIPLE_CONDITION = `${BACKEND_API}reconciliationReport/getReconciliationByMultipleConditions`;

// UPDATE MERCHANT BANK DETAILS
export const UPDATE_MERCHANT_BANK_DETAILS = `${BACKEND_API}merchant/onboard/savebankDetails`;

// verify account number and ifsc code
export const ACC_NUM_IFSC_VERIFY_API = `${BACKEND_API}merchant/ekyc/bankVerification`;

/* get details by ifsc */
export const IFSC_VERIFY_API = `${BACKEND_API}merchant/ekyc/findByIfsc`;

// verify email is pre verified or not
export const VERIFY_MERCHANT_ONBOARD_EMAIL = `${BACKEND_API}merchant/onboard/verified/email
`;

// verify mobile is pre verified or not
export const VERIFY_MERCHANT_ONBOARD_MOBILE = `${BACKEND_API}merchant/onboard/verified`;

export const SAVE_ORGANISATIONAL_TYPE = `${BACKEND_API}api/organisational-types/save`;

export const GET_ALL_ORGANISATIONAL_TYPE = `${BACKEND_API}api/organisational-types/getAll`;

export const GET_ALL_ORGANISATIONAL_TYPE_WITH_ACTIVE = `${BACKEND_API}api/organisational-types/getAllWithActive`;

export const GET_ALL_ACTIVE_VEHICAL_MASTER = `${BACKEND_API}admin/vehicleMaster/getAllSecondPhase`;

export const GET_ALL_VEHICLE_COMMERCIAL_TYPE_WITH_ACTIVE = `${BACKEND_API}api/vehicle-commercial-types/getAllWithActive`;

export const GET_ALL_VEHICLE_SETTLEMENT_TYPE_WITH_ACTIVE = `${BACKEND_API}admin/getAllVehicleSettlementType/isActiveTrue`;

export const GET_ALL_VEHICLE_COMMERCIAL_WITH_ACTIVE = `${BACKEND_API}admin/getAllVehicleCommercial/isActiveTrue`;

export const GET_ALL_VEHICLE_TYPE_WITH_ACTIVE = `${BACKEND_API}merchant/paymentType/getALLPaymentTypeWithSubType`;

export const GET_ALL_VEHICLE_SUB_TYPE_WITH_ACTIVE = `${BACKEND_API}admin/vehicleSubType/getAllActive`;

export const SUBMITTED_VEHICLE_SUBTYPE = `${BACKEND_API}admin/vehicleSubType/getAll`;

export const SUBMITTED_VEHICLE_TYPE = `${BACKEND_API}merchant/paymentType/getAllAtiveAndDisable`;

export const SUBMITTED_VEHICLE_COMMERCIAL = `${BACKEND_API}admin/getAllVehicleCommercial`;

export const SAVE_VEHICAL_COMMERCIAL_TYPE = `${BACKEND_API}api/vehicle-commercial-types/save`;

export const SAVE_VEHICAL_SETTLEMENT_TYPE = `${BACKEND_API}admin/saveVehicleSettlementType`;

export const GET_ALL_VEHICAL_COMMERCIAL_TYPE = `${BACKEND_API}api/vehicle-commercial-types/getAll`;

export const GET_ALL_VEHICAL_SETTLEMENT_TYPE = `${BACKEND_API}admin/getAllVehicleSettlementType`;

export const GET_ALL_VEHICAL_MASTER_FORMS = `${BACKEND_API}admin/vehicleMaster/getAllActive`;

export const GET_ALL_VEHICAL_MASTER_FORMS_EKYC = `${BACKEND_API}admin/vehicleMaster/findVehicleMasterByServiceType`;

export const GET_ALL_ACTIVE_DISABLE_VEHICAL_MASTER = `${BACKEND_API}admin/vehicleMaster/getAll`;

export const CREATE_SURYODAY_SID_API =
  "https://merchant-admin-panel-backend.patroni.site/admin/sidMaster/createSidForSuryoday";

export const SAVE_VEHICLE_MASTER_FORM = `${BACKEND_API}admin/vehicleMaster/save`;

export const SAVE_VEHICLE_MASTER_UPDATE_FORM = `${BACKEND_API}admin/vehicleMaster/update`;

export const SAVE_ORGANISATIONAL_TYPE_UPDATE_FORM = `${BACKEND_API}api/organisational-types/update`;

// export const  GET_ALL_MERCHANT_PAYOUT_API_TEST =`${BACKEND_API}merchant/getallmerchant-validation`;

export const GET_LIVE_TXN_REPORT_ADVANCE_FILTER = `${BACKEND_API}merchant/reports/getreportByConditionWithoutMid`;

export const LIVE_PAYIN_MORE_FILTER_API = `${BACKEND_API}merchant/reports/getreportByMultpalConditionWithoutMID`;

export const LIVE_PAYIN_MORE_FILTER_API_CSV_DOWNLOAD = `${BACKEND_API}merchant/reports/getreportByMultpalConditionWithoutMIDForCsvDownlload`;

export const GET_ALL_TEMPORARY_REQUEST_DATA = `${BACKEND_API}merchant/withdrawal/period/getAllWithdrawalRequest`;

export const GET_ALL_DAILY_TRANSACTION_DATA_PAYOUT = `${BACKEND_API}merchant/payoutRagister/getAllLiveTransactionsForOneDay`;

export const GET_ALL_DAILY_TRANSACTION_DATA_CHARGEBACK = `${BACKEND_API}getAllLiveTransactionsForOneDayChargeBackData`;

export const GET_ALL_BY_ID_USING_GET = `${BACKEND_API}admin/vehicleMaster/getbyId/`;

export const GET_ALL_PHASE2_SUBMITTER = `${BACKEND_API}merchant/vehicleMasterSubPaymentTypeService/getAllVehicleMasterSubPaymentTypeService`;

export const GET_ALL_DAILY_TRANSACTION_DATA_WITHDRAWL = `${BACKEND_API}merchant/withdrawal/getAllLiveTransactionsForOneDayWithdrawalData`;

export const GET_ALL_DAILY_TRANSACTION_DATA_RECONCILIATION = `${BACKEND_API}reconciliationReport/getAllLiveTransactionsForOneDayReconciliationData`;

export const GET_ALL_DAILY_TRANSACTION_DATA_PAYOUT_BY_MID = `${BACKEND_API}merchant/payoutRagister/getAllLiveTransactionsForOneDay/`;

export const GET_ALL_DAILY_TRANSACTION_CHARGEBACK_ = `${BACKEND_API}chargeBack/ByMultpalConditionWithoutMid`;

export const CHANGE_TXN_STATUS_PAYOUT = `${BACKEND_API}merchant/payoutRagister/update-txn-status`;

export const GET_ALL_DAILY_TRANSACTION_CHARGEBACK_BY_MID = `${BACKEND_API}getAllLiveTransactionsForOneDay/`;

export const GET_ALL_DAILY_TRANSACTION_WITHDRAWL_BY_MID = `${BACKEND_API}merchant/withdrawal/getAllLiveTransactionsForOneDay/`;

export const GET_ALL_DAILY_TRANSACTION_RECONCILIATION_BY_MID = `${BACKEND_API}reconciliationReport/getAllLiveTransactionsForOneDay/`;

export const CALLBACK_PAYOUT_BY_MID = `${BACKEND_API}payoutRouting/findByMid/`;

export const CHECK_CALLBACK_FOR_PAYOUT = `${BACKEND_API}payoutRouting/CheckPayoutCallBack`;

export const CALLBACK_PAYIN_BY_MID = `${BACKEND_API}merchant/onboard/getByMid/`;

export const CHECK_CALLBACK_PAYIN = `${BACKEND_API}merchant/payin/checkPayinCallbackUrl`;

export const GET_ALL_MERCHANT_MASTER = `${BACKEND_API}api/master-merchants`;

export const GET_ALL_MERCHANT_MASTER_PHASE_1_APPLICATION = `${BACKEND_API}api/master-merchants/getBy/MasterMerchantPrefix`;

export const GET_ALL_DOMAIN = `${BACKEND_API}api/domain/getAllDomains`;
export const GET_ALL_PROCESSOR = `${BACKEND_API}api/processor`;

export const LIVE_TRANSACTION_PAYOUT_WITHOUT_MID = `${BACKEND_API}merchant/payoutRagister/merchantPayoutRegister/byMultipleConditionWithoutMid`;

export const GET_ALL_SCHEME = `${BACKEND_API}api/schemes`;

export const GET_ALL_BANK = `${BACKEND_API}api/banks`;

export const GET_ALL_SWITCH_DATA = `${BACKEND_API}api/switches`;

export const GET_ALL_AGGREGATOR_DATA = `${BACKEND_API}api/aggregators`;

export const GET_TXN_REPORT = `${BACKEND_API}merchant/getAllMerchantTransactionCalculation`;

export const DISABLE_VEHICLE_MASTER = `${BACKEND_API}admin/vehicleMaster/disable`;

export const ENABLE_VEHICLE_MASTER = `${BACKEND_API}admin/vehicleMaster/enable`;

export const VEHICLE_MASTER_PHASE_2_SAVE = `${BACKEND_API}merchant/vehicleMasterSubPaymentTypeService/save/VehicleMasterSubPaymentTypeService`;

export const VEHICLE_MASTER_PHASE_2_SUBMITTED = `${BACKEND_API}admin/vehicleMaster/getAllSecondPhase`;

export const VEHICLE_MASTER_PHASE_2_SUBMITTED_BY_ID = `${BACKEND_API}admin/vehicleMaster/getbyId/`;

export const SUBMITTED_PAYOUT = ` ${BACKEND_API}merchant/payoutRagister/getAllPayoutByStatus/Submitted`;

export const FETCH_PAYOUT_DETAILS = `${BACKEND_API}merchant/payoutRagister/getAllPayout/`;

export const APPROVE_REJECT_PAYOUT = `${BACKEND_API}merchant/payoutRagister/reject`;

export const SINGLE_PAYIN_REPORT = `${BACKEND_API}merchant/reports/getreport`;

export const GET_PAYIN_BY_MULTIPLE_FILTER = `${BACKEND_API}merchant/reports/getReportBuMultipalConditionWithCountTxnStatusCode`;

export const SAVE_WITHDRAWL_PERCENTAGE = `${BACKEND_API}merchant/withdrawal/period/update`;

export const FETCH_ALL_MERCHANT_PAYIN_ROUTING_ONBORDING = `${BACKEND_API}admin/MerchantRouting/getMerchantPayin`;

export const FETCH_ALL_MERCHANT_PAYOUT_ROUTING_ONBORDING = `${BACKEND_API}admin/MerchantRouting/getMerchantPayout`;

export const FETCH_ALL_MERCHANT_EKYC_ROUTING_ONBORDING = `${BACKEND_API}Admin/ekycRouting/getallmerchant-Ekyc`;

export const FETCH_ALL_SUBMITTED_EKYC_ROUTING = `${BACKEND_API}Admin/ekycRouting/getAllRouting`;

export const FETCH_ALL_MERCHANT_EKYC_ROUTING_TOOLS = `${BACKEND_API}Admin/ekycRouting/getallmerchant-Ekyc/tools`;

export const AGGREGATOR_SAVE = `${BACKEND_API}api/master-merchants/save`;

export const GET_ALL_AGGREGATOR = `${BACKEND_API}api/master-merchants`;

export const GET_ALL_PRIVILAGES = `${BACKEND_API}admin/privileges/getAllPrivileges/subType`;

export const GET_ALL_MASTER_MERCHANT_PRIVILAGES = `${BACKEND_API}admin/privileges/getAllAdminPrevileges/`;

export const GET_ALL_PRIVILAGES_BY_ID = `${BACKEND_API}admin/privileges/getByMasterMerchntId`;

export const FETCH_PAYIN_FOR_ACKNOWLEDGMENT = `${BACKEND_API}merchant/reports/getAllCallBackAcknowledgement`;

export const AGGREGATOR_UPDATE = `${BACKEND_API}api/master-merchants/update`;

export const EnableDisableAggragator = `${BACKEND_API}api/master-merchants/`;

export const GET_ALL_USER = `${BACKEND_API}api/aggregators/subUser/getByMasterMerchntId/`;

export const GET_ALL_SUB_USER = `${BACKEND_API}api/aggregators/subUser/getAll`;

export const AGGREGATOR_USERS_SAVE = `${BACKEND_API}api/aggregators/subUser/save`;

export const GET_USER_MANAGEMENT_DATA_BY_ID = `${BACKEND_API}api/aggregators/subUser/`;

export const USER_UPDATE = `${BACKEND_API}api/aggregators/subUser/update`;

export const FRM_BLOCK_USER = `${BACKEND_API}merchant/frm-block/save`;

export const FETCH_FRM_USERS = `${BACKEND_API}merchant/frm-block/get`;

export const FETCH_MERCHANT_FOR_MASTERS_FORMS = `${BACKEND_API}admin/vehicleMaster/findVehicleMasterByServiceType`;

export const FETCH_PAYOUT_MARTER_PROVIDERS = `${BACKEND_API}merchant/merchantPayoutMaster/getAllPaymentProvider`;

export const FETCH_MERCHANT_FOR_SID = `${BACKEND_API}admin/sidMaster/getMasterMaschantDetailDemo`;

export const FETCH_PAYU_SID_LIST = `${BACKEND_API}admin/sidMaster/viewAllSidDetailsForPayU`;

export const FETCH_SURYODAY_SID_LIST = `${BACKEND_API}admin/sidMaster/viewAllSidDetailsForSuryoday`;

export const GET_ALL_ACTIVE_VEHICAL_MASTER_FOR_SID = `${BACKEND_API}admin/sidMaster/getVehicleForSid`;

export const VEHICLE_MASTER_PHASE_2_UPDATE = `${BACKEND_API}merchant/vehicleMasterSubPaymentTypeService/update/updateVehicleSubPaymentTypeService`;

export const GET_ALL_SID = `${BACKEND_API}admin/sidMaster/getAllSid`;

export const GET_ALL_DAILY_TRANSACTION_DATA_BOX_WITH_FILTER = `${BACKEND_API}LiveReport/getAllMerchantByCondition`;

export const POST_SID_MASTER_V = `${BACKEND_API}admin/sidMaster/save`;

export const FETCH_ALL_SID_MASTER_DETAILS = `${BACKEND_API}admin/sidMaster/getAllSid`;

export const SID_DISABLE_API = `${BACKEND_API}admin/sidMaster/disableSid/`;

export const GET_All_MAPPED_SID = ` ${BACKEND_API}admin/MerchantRouting/getall-mapped-sid/`;

export const UPDATE_SID_MASTER = `${BACKEND_API}admin/sidMaster/UpdateSid`;

export const CHECK_DUPLICATE_ENTRIES = `${BACKEND_API}merchant/merchantPayoutMaster/getMerchantPayoutMasterWithOneTransferType`;

export const SUBMITTED_PHASE1_APPLICATIONS = `${BACKEND_API}merchant/onboard/findApplicationStatusAndStages`;

export const HANDLE_PHASE1_APPROVE = `${BACKEND_API}merchant/onboard/updateStatus`;

export const HANDLE_PHASE1_REJECT = `${BACKEND_API}merchant/onboard/updateStatus`;

export const GET_MERCHANT_BY_ID = `${BACKEND_API}merchant/onboard/getmerchantById/`;

export const GET_ALL_PAYMENT_TYPE = `${BACKEND_API}merchant/paymentType/getALLPaymentType`;

export const SAVE_UPDATED_PAYMENT_SERVICES = `${BACKEND_API}merchant/onboard/updatePaymentTypeService/`;

export const UPDATE_PAYOUT_SUBMIT = `${BACKEND_API}merchant/merchantPayoutMaster/update/`;

export const ENABLE_DISABLE_PAYOUT = `${BACKEND_API}merchant/merchantPayoutMaster/`;

export const TOTAL_TRANSACTION = `${BACKEND_API}merchant/dashboard/totaltransection`;

export const TOTAL_TRANSACTION_AMOUNT = `${BACKEND_API}merchant/dashboard/totaltransectionamount`;

export const TREND_CHART_API = `${BACKEND_API}merchant/dashboard/getdashboardTrendchart`;

export const API_DASHBOARD_WITH_CONDITION = `${BACKEND_API}merchant/dashboard/combined-api`;

// tools section:

export const GET_ALL_MERCHANT_DATA = `${BACKEND_API}merchant/getallmerchant`;

export const FETCH_FULL_MERCHANT_DATA = `${BACKEND_API}merchant/onboard/getallmerchantData`;

export const FETCH_ONBOARD_MERCHANT_DETAILS = `${BACKEND_API}merchant/onboard/getByMid/`;

export const UPDATE_ONBOARD_MERCHANT_DETAILS = `${BACKEND_API}merchant/onboard/updateOnboard`;

export const UPDATE_BANK_DETAILS_STAGE2 = `${BACKEND_API}merchant/onboard/updateOnboard/BankDetailStage2`;

export const GET_ALL_MDR_BY_MID = `${BACKEND_API}merchant/mdr/getAllMdrByMid/`;

export const GET_SETTLEMENT_INFO = `${BACKEND_API}merchant/mdr/getSettlement`;

export const UPDATE_MDR_PERCENTAGE = `${BACKEND_API}merchant/mdr/updateMdrPercentage`;

export const ADD_MDR_SETTLEMENT = `${BACKEND_API}merchant/mdr/saveSettlement`;

export const GET_DEFAULT_SERVICES_MDR = `${BACKEND_API}merchant/PayoutTransactionFees/findByMid/`;

export const SAVE_SERVICE_CHARGE = `${BACKEND_API}merchant/save/serviceCharge`;

export const FETCH_BUSINESS_CATEGORIES = `${MERCHANT_BACKEND_API}merchant/business/getAllBusinessType`;

export const FETCH_REGISTRATION_TYPES = `${MERCHANT_BACKEND_API}merchant/registration/getAllRegistrationType`;

export const FETCH_BUSINESS_TYPES = `${MERCHANT_BACKEND_API}merchant/company/getAllCompanyType`;

export const ONBOARD_SAVE_PHASE1 = `${BACKEND_API}merchant/onboard/save`;

export const FETCH_PAYMENT_TYPES = `${BACKEND_API}merchant/paymentType/getALLPaymentType`;

export const FETCH_CITY_STATE_BY_PINCODE = `${MERCHANT_BACKEND_API}merchant/address/getCityStateByPinCode/`;

export const SAVE_MERCHANT_DOCUMENT = `${BACKEND_API}merchant/Account/savemerchantdocuments`;

export const fIRST_STAGE_APPROVE_SECOND_NOT_SUBMITTED = `${BACKEND_API}merchant/onboard/FirstStageApproveAndSecondNotSubmitted`;

export const SUBMITTED_VENDOR = `${BACKEND_API}merchant/vendor/getAllVendors/Submitted`;

export const VIEW_VENDOR_DETAILS = `${BACKEND_API}merchant/vendor/getVendorById/`;

export const APPROVE_VENDOR = `${BACKEND_API}merchant/vendor/updateStatus`;

export const UPDATE_WALLET_BALANCE = `${BACKEND_API}merchant/wallet/update`;

export const GET_WALLET_BALANCE = `${BACKEND_API}merchant/wallet/status/pending`;

export const CHARGEBACK_UPLOAD = `${BACKEND_API}chargeBack/upload`;

export const SAVE_WITHDRAW = `${BACKEND_API}merchant/withdrawal/save`;

export const UPDATE_WITHDRAWL = `${BACKEND_API}merchant/withdrawal/updateWithdrawal`;

export const GET_ALL_PENDING_WITHDRAWL = `${BACKEND_API}merchant/withdrawal/getAllPandingWithdrawal`;

export const SAVE_DROP_CREDIT = `${BACKEND_API}admin/dropCredit/save`;

export const SAVE_DATE_AND_FILE_TYPES = `${BACKEND_API}reconciliationReport/save/date`;

export const FETCH_UPLOAD_HISTORY = `${BACKEND_API}reconciliationReport/getDate`;

export const FRM_BLOCK_UPLOAD = `${BACKEND_API}merchant/frm-block/upload`;

export const FETCH_ALL_PAYIN_SERVICES = `${BACKEND_API}merchant/dashboard/getpaymentserviceswithpercentage`;

export const REPORT_ERROR_CODES = `${BACKEND_API}LiveReport/getDataBy/timeframe`;

export const GET_ALL_INITIAL_SID = `${BACKEND_API}admin/sidMaster/getAllSid`;

export const HANDLE_SEARCH_LIMIT = `${BACKEND_API}admin/MerchantRouting/getall-mapped-sid/`;

export const CHECK_MAXIMUM_AMOUNT_LIMIT = `${BACKEND_API}admin/MerchantRouting/save`;

export const GET_DETAILS = ` ${BACKEND_API}admin/MerchantRouting/get-mapped-sid/byMid/`;

export const ENABLE_DISABLE_PAYOUT_ROUTING = ` ${BACKEND_API}payoutRouting/`;
export const ENABLE_DISABLE_VIRTUAL_ACC = ` ${BACKEND_API}admin/MerchantPayoutRouting/`;
export const UPDATE_MERCHANT = `${BACKEND_API}payoutRouting/updateMerchantPayoutMaster`;
export const UPDATE_MERCHANT_ALl = `${BACKEND_API}admin/MerchantPayoutRouting/updateAllData `;

export const UPDATE_ALL_DATA_ADMIN_ = `${BACKEND_API}admin/MerchantRouting/updateAllData`;

export const SAVE_FRM_DATA = `${BACKEND_API}merchant/frm/save`;

export const GET_ALL_FRM = `${BACKEND_API}merchant/onboard/getallforFRM`;

export const SIDMASTER_GET_ALL_SID = `${BACKEND_API}admin/sidMaster/getAllSid`;

export const EKYC_SAVE = ` ${BACKEND_API}Admin/ekycRouting/save`;

// export const GET_DETAILS = ${BACKEND_API}admin/MerchantRouting/get-mapped-sid/byMid/

export const GET_ALL_FOR_ACCOUNT = ` ${BACKEND_API}merchant/onboard/getallforAccount`;

export const ACCOUNT_DETAILS_UPLOAD = ` ${BACKEND_API}merchant/Account/details/upload`;

export const DEFAULT_SERVICES_MDR = ` ${BACKEND_API}merchant/PayoutTransactionFees/save`;

export const MDR_TYPE_FETCH = ` ${BACKEND_API}merchant/Account/getAllServices/`;

export const WITHDRAW_TYPE = ` ${BACKEND_API}merchant/withdrawal-type/getAllwithdrawal-type`;

export const View_PDF = ` ${BACKEND_API}merchant/onboard/view-pdf/`;
export const GET_HOLD_DATA = `${BACKEND_API}merchant/hold/getholddata/`;

export const CHANGE_AMOUNT_HOLD_DEPOSITE = `${BACKEND_API}merchant/`;

export const GET_ALL_DATA_ADMIN_HOLD = `${BACKEND_API}merchant/holdAmountpercentage/getMerchantHoldPercentageByMid/`;
export const GET_SECURITY_DATA = `${BACKEND_API}merchant/securitydeposit/getsecuirtydata/`;
export const ALL_GET_SECURITY_DATA = `${BACKEND_API}merchant/securitydeposit/save`;

export const GET_ALL_MERCHANT = `${BACKEND_API}merchant/getallmerchant`;
export const GET_ALL_DEPOSIT_AND_HOLD = `${BACKEND_API}merchant/release/getdepositeAndHoldAmount`;

export const RELEASE_AMOUNT = `${BACKEND_API}merchant/release/getdepositeAndHoldAmount`;

export const GET_VIRTUAL_ACCOUNT_DATA = `${BACKEND_API}merchant/merchantPayoutMaster/getAllMerchantPayoutMasterDistinctData/`;

export const POST_MERCHANT_SAVE_1 = `${BACKEND_API}payoutRouting/saveMerchantPayoutRouting`;

export const POST_MERCHANT_SAVE = `${BACKEND_API}admin/MerchantPayoutRouting/save`;

export const ONBOARDING_PAYOUT_ROUTING_SAVE = `${BACKEND_API}payoutRouting/saveMerchantPayoutRouting`;

export const GET_PREV_MAPPED_DETAILS = `${BACKEND_API}admin/MerchantRouting/get-mapped-sid/byMid/`;

export const GET_PREV_MAPPED_DETAILS_PAYOUT = `${BACKEND_API}admin/MerchantPayoutRouting/get-mapped-masterId/byMid/`;

// export const GET_PREV_MAPPED_DETAILS_PAYOUT = `${BACKEND_API}admin/MerchantPayoutRouting/get-mapped-masterId/byMid/`;

export const HANDLE_SEARCH_LIMIT_PAYOUT = `${BACKEND_API}admin/MerchantPayoutRouting/getall-mapped-masterId/`;

export const MASTER_MERCHANT_ENABLE_DISABLE = `${BACKEND_API}api/master-merchants/`;

export const GET_ALL_MERCHANT_TRANSACTION = `${BACKEND_API}merchant/getAllMerchantWithTransaction`;

export const PAYOUTROUTING_FIND_MERCHANT = `${BACKEND_API}payoutRouting/findMerchantByMid/`;

export const POST_WALLET_BALANCE = `${BACKEND_API}merchant/thirdPartyApiPayout/get/walletbalance`;

export const POST_PAYOUT_API_TEST = `${BACKEND_API}merchant/payoutRagister/payout-api-test`;

export const TOOLS_PAYIN_ENABLE_DISABLE = `${BACKEND_API}admin/MerchantRouting/`;

export const GET_REPORT_API = `${BACKEND_API}LiveReport/allReports/timeframe`;

export const GET_TXN_TIMELINE = `${BACKEND_API}merchant/payoutRagister/transaction-details`;

export const GET_TN_TIMELINE_PAYIN = `${BACKEND_API}merchant/payin/getPayinTxn`;

export const ENABLE_DISABLE_TOOLS_PAYIN = `${BACKEND_API}admin/MerchantRouting/`;

export const PHASE2_SUBMIITED = `${BACKEND_API}merchant/onboard/findbystage2/Submitted`;

export const UPDATE_STAGE2 = `${BACKEND_API}merchant/onboard/updateStage2`;

export const HANDLE_VIEW_DATA = `${BACKEND_API}merchant/onboard/viewData/`;

export const GET_DASHBOARD_CURRENT_DATA = `${BACKEND_API}merchant/dashboard/getamountdata/`;

export const SAVE_DEPOSIT = `${BACKEND_API}merchant/securitydeposit/save`;

export const ENABLE_DISABLE_USER_MANAGEMENT = `${BACKEND_API}api/aggregators/subUser/`;

export const GENERATE_ARCHIVED_REPORT = `${BACKEND_API}ReportVault/merchant/csv`;
export const GET_ALL_ARCHIVED_REPORTS = `${BACKEND_API}ReportVault/merchant/csv/status/getAll`;
export const VIEW_REPORT_VAULT = `${BACKEND_API}ReportVault/merchant/view/`;
export const DOWNLOAD_ARCHIVED_REPORT = `${BACKEND_API}ReportVault/merchant/csv/download/`;
export const DOWNLOAD_REPORTS_CSV_BY_TYPE = `${BACKEND_API}ReportVault/merchant/csv`;
export const DOWNLOAD_REPORT_VAULT = `${BACKEND_API}ReportVault/merchant/download/`;
export const INITIATE_TRANSACTION_REPORT = `${BACKEND_API}TransactionReportDownload/reports/initiate-download`;
export const GET_ALL_TRANSACTION_REPORTS = `${BACKEND_API}TransactionReportDownload/reports/get-all-reports`;
export const DOWNLOAD_TRANSACTION_REPORT = `${BACKEND_API}TransactionReportDownload/reports/download/`;
export const GET_ALL_VIRTUAL_ACCOUNTS_REPORT = `${BACKEND_API}TransactionReportDownload/reports/get-all-virtual-accounts`;

export const GET_BY_SETTLEMENT_MID = `${BACKEND_API}admin/settlement/findbymid/`;

export const CHARGEBACK_UPDATE = `${BACKEND_API}chargeBack/findBymid/`;

export const HOLD_AMOUNT_REPORT = `${BACKEND_API}merchant/hold/getHoldReport/`;

export const GET_DEPOSIT_REPORT = `${BACKEND_API}merchant/merchantDepositReport/getDepositeReport/`;

export const GET_PAYOUT_REPORT = `${BACKEND_API}merchant/payoutRagister/getAllPayoutByMid/`;

export const GET_WITHDRAWAL_REPORT = `${BACKEND_API}merchant/withdrawal/getAllSuccessAndReject/`;

export const GURANTEE_REPORT = `${BACKEND_API}admin/guarantAmount/findAllByMid/`;

export const AVAILABLE_CREDIT_AMOUNT = `${BACKEND_API}admin/dropCredit/`;

export const SETTLEMENT_ADJUSTMENT_REPORT = `${BACKEND_API}admin/get-by-mid-and-remark/`;

export const VENDOR_REPORT = `${BACKEND_API}merchant/vendor/getAllVendorsbyMid/`;

export const RELEASE_REPORT = `${BACKEND_API}merchant/release/getBy/`;

export const WALLETBALANCE_REPORT = `${BACKEND_API}merchant/wallet/findByMid/`;

export const CHARGEBACK_UPDATE_REPORT = `${BACKEND_API}chargeBack/update`;

export const WITHDRAWL_DELETE = `${BACKEND_API}merchant/withdrawal/deleteBy/`;

// export const GET_ALL_MCC_CODE = `${BACKEND_API}ucoBank/getAllMccCode`;

export const GET_ALL_BANK_MCC_CODE = `${BACKEND_API}ucoBank/getAllBankMccCodes`;

export const GET_MCC_CODE_BY_BANK = `${BACKEND_API}ucoBank/getMccCodes/BankName`;

export const GET_CHANNEL_AND_TXN_SET = `${BACKEND_API}ucoBank/getChannelAndTransacetionSet`;

export const GET_DEVICE_MODAL = `${BACKEND_API}ucoBank/getDeviceModel`;

export const SAVE_BANK_ONBOARD = `${BACKEND_API}yesBank/onBoard/bank`;

export const ENABLE_SIDMASTER = `${BACKEND_API}admin/sidMaster/enableSid/`;

export const GET_ALL_DISABLED_SID_FOR_MASTERS = `${BACKEND_API}admin/sidMaster/getAllDisableSid`;

export const API_FOR_VIEW_LOGS = `${BACKEND_API}admin/sidMaster/getSidLogs/`;

export const GET_ALL_CUB_ONBOARDING = `${BACKEND_API}ucoBank/getAllOnBoarding`;

export const GET_UCB_BANK_STATUS = `${BACKEND_API}ucoBank/getstatus/`;

export const VIEW_ALL_MERCHANT_FOR_SQR = `${BACKEND_API}admin/MerchantRouting/viewAllMerchantForSqr`;

export const GET_ALL_FREE_SID = `${BACKEND_API}admin/sidMaster/getAllFreeSid`;

export const SAVE_QR_ROUTING = `${BACKEND_API}admin/MerchantRouting/saveSqrRouting`;

export const CHECK_CALLBACK_STATUS = `${BACKEND_API}util/getStatus`;

export const GET_ALL_CREDIT = `${BACKEND_API}admin/dropCredit/getAllCreditWithAndWithoutMid`;

export const GET_ALL_DEBIT = `${BACKEND_API}admin/dropCredit/getAllDebitWithAndWithoutMid`;

export const GET_AMOUNT_RULES = `${BACKEND_API}merchant/get/AmountRule/`;

export const GET_AMOUNT_RULES_MID = `${BACKEND_API}merchant/get/PgAmountRuleNew/`;

export const GET_WHITELIST_AMOUNT_RULES = `${BACKEND_API}merchant/whitelist-pg-rule/get-by-mid`;

export const DELETE_ALL_RULE = `${BACKEND_API}merchant/whitelist-pg-rule/delete`;

export const UPDATE_WHITELIST_RULE = `${BACKEND_API}merchant/whitelist-pg-rule/update`;

export const ENABLE_DISABLE_RULE_SID = `${BACKEND_API}merchant/whitelist-pg-rule/toggle-status`;

export const GET_WHITELIST_AMOUNT_RULES_SID = `${BACKEND_API}merchant/whitelist-pg-rule/get-by-sid`;

export const GET_FRM_AMOUNT_RULES_SID = `${BACKEND_API}merchant/get/AmountRule/`;

export const GET_PAYOUT_AMOUNT_RULES = `${BACKEND_API}merchant/get/payoutAmountRule/`;

export const SAVE_AMOUNT_RULE = `${BACKEND_API}merchant/save/AmountRule`;

export const SAVE_WHITELIST_AMOUNT_RULE = `${BACKEND_API}merchant/whitelist-pg-rule/save`;

export const SAVE_PAYOUT_AMOUNT_RULE = `${BACKEND_API}merchant/save/payoutAmountRule`;

export const GET_RULES_API = `${BACKEND_API}merchant/get/AmountRule/distinct`;

export const GET_WHITELIST_RULES_API = `${BACKEND_API}merchant/whitelist-pg-rule/get-distinct`;
// export const GET_WHITELIST_RULES_API = `${BACKEND_API}merchant/whiteListpgrule/get/WhiteListAmountRule/distinct`;

export const GET_WHITELIST_RULES_API_ = `${BACKEND_API}merchant/whiteListpgrule/get/WhiteListAmountRule/distinct`;

export const GET_PAYOUT_RULES_API = `${BACKEND_API}merchant/get/payoutAmountRule/distinct`;

export const UPDATE_MID_RULES = `${BACKEND_API}merchant/suffle/AmountRule`;

export const UPDATE_MID_RULE2S = `${BACKEND_API}merchant/update/AmountRule`;

export const UPDATE_WHITELIST_MID_RULES = `${BACKEND_API}merchant/whiteListpgrule/update/WhiteListAmountRule`;

export const UPDATE_MID_PAYOUT_RULES = `${BACKEND_API}merchant/suffle/payoutAmountRule`;

export const DISABLE_PAYOUT_RULE = `${BACKEND_API}merchant/disable/payoutAmountRule/`;

export const DISABLE_RULE = `${BACKEND_API}merchant/disable/AmountRule/`;

export const DISABLE_RULE_FRM = `${BACKEND_API}merchant/disableALl/PgRule/`;

export const DISABLE_WHITELIST_RULE = `${BACKEND_API}merchant/whiteListpgrule/delet/AmountRule/`;

export const FETCH_VEHICLE_BY_SERVICE_TYPE = `${BACKEND_API}admin/vehicleMaster/findVehicleMasterByServiceType`;

export const GET_RESPONSE_CODE = `${BACKEND_API}admin/payin/findByTxnId/`;

export const GET_BBPS_MASTER = `${BACKEND_API}bbps/MasterData/getMaster`;

export const POST_BBPS_MASTER_FORM = `${BACKEND_API}bbps/MasterData/save`;

export const DISABLE_BBPS_MASTER = `${BACKEND_API}bbps/MasterData/disable`;

export const API_FOR_ADVANCE_FILTER = `${BACKEND_API}merchant/CSV/Download/AdvanceFilter`;

export const API_FOR_MULTIPLE_FILTER = `${BACKEND_API}merchant/CSV/Download/payin`;

export const BBPS_ROUTING_SAVE = `${BACKEND_API}bbps/routing/save`;

export const BBPS_ROUTING_GET = `${BACKEND_API}bbps/routing/getAll`;

export const BBPS_ROUTING_DISABLE = `${BACKEND_API}bbps/routing/disable`;

export const BBPS_ROUTING_ENABLE = `${BACKEND_API}bbps/routing/enable`;

export const SETTLEMENT_TYPE_GET = `${BACKEND_API}all`;

export const MASTER_MERCHANT_SERVICES_POST = `${BACKEND_API}api/master-merchants/service-md-setting`;

export const REPORTED_PAYIN_ISSUE_CONTROLLER_REPORT_API = `${BACKEND_API}reportedPayinIssueController/getAllReportedPayinIssue`;

export const MASTER_MERCHANT_PHASE2 = `${BACKEND_API}api/master-merchants/service-md-settings/`;

export const EDIT_MASTER_MERCHANT_PHASE2 = `${BACKEND_API}api/master-merchants/service-md-setting/`;

export const LIVE_GUARANTEE_MULTIPLE_FILTER_API = `${BACKEND_API}admin/guarantAmount/chargeBack/ByMultpalCondition`;

export const MOBILE_APP_ONBOARDING_APPROVED = `${BACKEND_API}yesBank/getAllApproved`;

export const YES_BANK_ONBOARD_WITH_MID = `${BACKEND_API}yesBank/yesbankOnBoard/`;

export const GET_DOCUMENT_UPLOADED_BY_ID = `${BACKEND_API}merchant/document/view-filename/`;

export const GET_VIDEO_UPLOADED_BY_ID = `${BACKEND_API}videoGettingController/videoName/`;

export const GET_ALL_YES_ONBOARD = `${BACKEND_API}yesBank/getAllYesOnBoard`;

export const GET_ALL_PAYMENT_SERVICES = `${BACKEND_API}merchant/paymentType/getALLPaymentType`;

export const GET_ALL_SID_BY_VEHICLE = `${BACKEND_API}admin/sidMaster/getAllSidbyVehicle/`;

export const GET_ALL_SID_ = `${BACKEND_API}admin/MerchantRouting/get-mapped-sid/byMid/`;

export const GET_VIDEO_FILE = `${BACKEND_API}videoGettingController/videos/`;

export const GET_DOCUMENT_FILE = `${BACKEND_API}merchant/document/view-Documents/`;

export const APPROVED_MOBILE_APP_ONBOARD = `${BACKEND_API}yesBank/update`;

export const API_DASHBOARD_WITH_CONDITION1 = `${BACKEND_API}merchant/dashboard/combined-api1`;

export const API_DASHBOARD_WITH_CONDITION2 = `${BACKEND_API}merchant/dashboard/combined-api2`;

export const API_DASHBOARD_WITH_CONDITION3 = `${BACKEND_API}merchant/dashboard/combined-api3`;

export const API_DASHBOARD_WITH_CONDITION4 = `${BACKEND_API}merchant/dashboard/combined-api4`;
